import Cookies from 'js-cookie'
import { ipRegText } from './validate'

// 获取根域名
const rootDomain = () => {
  if(location.host.includes('localhost')) {
    return 'localhost'
  }
  if(new RegExp(`^${ipRegText}$`).test(location.hostname)) {
    return location.hostname
  }
  let hostArr = location.hostname.split('.')
  if(hostArr.length <= 2) {
    return hostArr.join('.')
  }
  return hostArr.slice(hostArr.length-2).join('.')
}

// 获取有效期：一个自然月
// const getExpires = () => new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
const getExpires = () => new Date(Date.now() + 24 * 60 * 60 * 1000)

let { COOKIE_TOKEN_KEY, COOKIE_TOKENTYPE_KEY } = window._env_
COOKIE_TOKEN_KEY = COOKIE_TOKEN_KEY || 'access_token'
COOKIE_TOKENTYPE_KEY = COOKIE_TOKENTYPE_KEY || 'token_type'

export function getToken() {
  const tokenType = Cookies.get(COOKIE_TOKENTYPE_KEY, { domain: rootDomain() })
  const accessToken = Cookies.get(COOKIE_TOKEN_KEY, { domain: rootDomain() })
  return accessToken ? tokenType + ' ' + accessToken : ''
}

// token和token类型存入cookie
export function setToken(accessToken, tokenType) {
  const expires = getExpires()
  Cookies.set(COOKIE_TOKEN_KEY, accessToken, { expires, domain: rootDomain() })
  Cookies.set(COOKIE_TOKENTYPE_KEY, tokenType, { expires, domain: rootDomain() })
}

export function removeToken() {
  Cookies.remove(COOKIE_TOKEN_KEY, { domain: rootDomain() })
  Cookies.remove(COOKIE_TOKENTYPE_KEY, { domain: rootDomain() })
}
